export default (element) => {
  const playButton = element.querySelector('[data-ticker-play]');

  const handlePlay = () => {
    if (playButton) [...playButton.children].forEach((child) => child.classList.toggle('hidden'));

    element.querySelectorAll('[data-ticker-tape]').forEach((ticker) => {
      if (ticker.classList.contains('is-playing')) {
        ticker.classList.remove('is-playing');
        ticker.classList.add('is-paused');
      } else {
        ticker.classList.remove('is-paused');
        ticker.classList.add('is-playing');
      }
    });
  };

  playButton?.addEventListener('click', handlePlay);
};
